const actionPrefix = 'app/feedback';

export const CLEAR_STATE = `${actionPrefix}/CLEAR_STATE`;
export const SUBMIT_FEEDBACK_REQUEST = `${actionPrefix}/SUBMIT_FEEDBACK_REQUEST`;
export const SUBMIT_FEEDBACK_SUCCESS = `${actionPrefix}/SUBMIT_FEEDBACK_SUCCESS`;
export const SUBMIT_FEEDBACK_FAILURE = `${actionPrefix}/SUBMIT_FEEDBACK_FAILURE`;

